import { Button, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import FeilSideBilde from "@/assets/feil-side.webp?inline";
import { Page } from "@/components";

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <main className="w-full">
      <Page className="flex flex-row flex-wrap gap-4">
        <div className="space-y-4">
          <Heading level={1} data-size="lg">
            {t("feilmelding.overskrift_404")}
          </Heading>
          <Paragraph className="whitespace-pre-wrap">
            {t("feilmelding.beskrivelse_404")}
          </Paragraph>
          <Button variant="primary" onClick={() => navigate({ to: "/" })}>
            {t("button.back-to-frontpage")}
          </Button>
        </div>
        <img
          className="mx-auto max-w-card w-full"
          src={FeilSideBilde}
          alt="Illustrasjon av fjernvarmeanlegg som mangler"
        />
      </Page>
    </main>
  );
};
